import { shade } from 'polished'
import styled from 'styled-components'

interface StatusCardLegacyListItemStyled {}

export const StatusCardLegacyListItemStyled = styled.div<StatusCardLegacyListItemStyled>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  padding: 1.25em;

  & + * {
    border-top: 1px solid ${(props) => props.theme.colors.content.border};
  }

  &:nth-child(2n-1) {
    background-color: ${(props) => shade(0.01, props.theme.colors.white)};
  }
`
